import BaseComponent from '../base/baseComponent';
const THRON_DNAME = {
    ST: 'stoneisland-cdn.thron.com',
    MO: 'moncler-cdn.thron.com',
};
const BRANDCONFIGS = {
    MO: {
        video: {
            clientId: 'moncler',
            sessId: 'ymo4nq',
        },
        audio: {
            clientId: 'moncler',
            sessId: 'ymo4nq',
        },
    },
    ST: {
        video: {
            sessId: 'ujzayc',
            clientId: 'stoneisland',
        },
        audio: {
            sessId: 'vxnhgf',
            clientId: 'stoneisland',
            waveColor: '#999999',
            waveProgressColor: '#000000',
            audioResponsive: false,
        },
    },
};
export default class ThronIntegrationComponent extends BaseComponent {
    constructor(element, mediatype, options) {
        super(element);
        this.defaultOptions = {
            noSkin: true,
            mouseWheelZoom: false,
            autoplay: true,
            loop: true,
            muted: true,
            disableUserProfiling: true,
            ignoreUserBehavior: true,
            pauseOtherPlayers: false,
        };
        this.mediatype = mediatype || 'video';
        this.isFirstPlay = true;
        if (options) {
            options.onPauseCallback && (this.onPauseCallback = options.onPauseCallback);
            options.onPlayCallback && (this.onPlayCallback = options.onPlayCallback);
            options.onCompleteCallback && (this.onCompleteCallback = options.onCompleteCallback);
            options.onInitCallback && (this.onInitCallback = options.onInitCallback);
            options.onTimeUpdate && (this.onTimeUpdate = options.onTimeUpdate);
        }
        //@ts-ignore
        window.thronInitTracker = [];
        const scriptSrc = `https://${THRON_DNAME[window.brandId || 'MO']}/shared/ce/bootstrap/1/scripts/embeds-min.js`;
        const existingScript = document.querySelector(`script[src="${scriptSrc}"]`);
        if (!existingScript) {
            const script = document.createElement('script');
            script.src = scriptSrc;
            document.head.appendChild(script);
        }
        this.initPlayerWhenAvailable(element);
    }
    initPlayerWhenAvailable(element) {
        const interval = setInterval(() => {
            //@ts-ignore
            if (window.THRONContentExperience) {
                clearInterval(interval);
                this.initPlayer(element);
            }
        }, 250);
    }
    match(max = null, min = null) {
        if (!max && !min) {
            return false;
        }
        let maxString = '';
        let minString = '';
        if (max) {
            //@ts-ignore
            maxString = `(max-width: ${parseFloat(window.mqObj[max]) - 1}px)${min ? ' and ' : ''}`;
        }
        if (min) {
            //@ts-ignore
            minString = `(min-width: ${window.mqObj[min]}px)`;
        }
        return window.matchMedia(`${maxString}${minString}`).matches;
    }
    initPlayer(playerEl) {
        let actualDisplayed = '';
        if (playerEl.dataset.optionMobileId !== null && playerEl.dataset.optionMobileId !== undefined) {
            this.sizeCheck(actualDisplayed, null, playerEl);
        }
        else {
            let id = playerEl.dataset.optionId;
            actualDisplayed = 'desktop';
            this.bindPlayer(id, actualDisplayed, null, playerEl);
        }
    }
    sizeCheck(actualDisplayed, player, playerEl) {
        let id;
        if (this.match(null, 'md') || window.matchMedia('(orientation: landscape)').matches) {
            id = playerEl.dataset.optionId;
            actualDisplayed = 'desktop';
        }
        else {
            actualDisplayed = 'mobile';
            if (playerEl.dataset.optionMobileId !== 'null') {
                id = playerEl.dataset.optionMobileId;
            }
            else {
                id = playerEl.dataset.optionId;
            }
        }
        this.bindPlayer(id, actualDisplayed, player, playerEl);
    }
    pauseVideo(pauseVideoElement, playerInstance) {
        var _a;
        (_a = this.pauseVideoElement) === null || _a === void 0 ? void 0 : _a.addEventListener('click', (e) => {
            e.preventDefault();
            if (pauseVideoElement.getAttribute('aria-pressed') === 'true') {
                this.pauseVideoElement.setAttribute('aria-pressed', 'false');
                playerInstance.play();
            }
            else {
                this.pauseVideoElement.setAttribute('aria-pressed', 'true');
                playerInstance.pause();
            }
        });
    }
    bindPlayer(id, actualDisplayed, player, playerEl) {
        let randomNumber = Math.floor(Math.random() * 10000000000000000);
        playerEl.id = 'thron_' + id + '_' + randomNumber;
        if (playerEl.dataset.optionBackground) {
            playerEl.classList.add('bg-mode');
            playerEl.parentElement.style.position = 'relative';
        }
        else {
            playerEl.style.height = 'inherit';
        }
        //BRAND OVERRIDE CONFIGS
        let brandOptions = BRANDCONFIGS[window.brandId || 'MO'][this.mediatype];
        let options = Object.assign(Object.assign(Object.assign(Object.assign({}, this.defaultOptions), { xcontentId: id }), brandOptions), this.$options);
        if (player) {
            player.destroy();
        }
        let dateStart = new Date();
        let hours = dateStart.getHours();
        let minutes = dateStart.getMinutes();
        let seconds = dateStart.getSeconds();
        let milliseconds = dateStart.getMilliseconds();
        let completeTimeStart = hours + 'h :' + minutes + 'm :' + seconds + 's :' + milliseconds + 'ms';
        //@ts-ignore
        player = window.THRONContentExperience('thron_' + id + '_' + randomNumber, options);
        this.playerInstance = player;
        player.on('pause', (playerInstance) => {
            var _a;
            (_a = this.pauseVideoElement) === null || _a === void 0 ? void 0 : _a.setAttribute('aria-pressed', 'true');
            this.onPauseCallback && this.onPauseCallback();
        });
        this.onPlayCallback &&
            player.on('play', (playerInstance) => {
                this.onPlayCallback(this.isFirstPlay);
                this.isFirstPlay && (this.isFirstPlay = false);
            });
        if (this.onCompleteCallback && this.loopTimes) {
            const onCompleteFunction = (playerInstance) => {
                this.onCompleteCallback(playerInstance);
                this.loopTimes -= 1;
                if (!this.loopTimes) {
                    player.off('complete', onCompleteFunction);
                }
            };
            player.on('complete', onCompleteFunction);
        }
        else if (this.onCompleteCallback) {
            player.on('complete', this.onCompleteCallback);
        }
        if (this.onInitCallback) {
            player.on('canPlay', (playerInstance) => {
                if (this.onInitCallback) {
                    this.onInitCallback(playerInstance);
                }
            });
        }
        if (this.onTimeUpdate) {
            player.on('timeupdate', (playerInstance) => {
                this.onTimeUpdate(playerInstance);
            });
        }
        player.on('ready', (playerInstance) => {
            var _a, _b, _c, _d, _e, _f, _g;
            // console.info('thronplayer ready: ', playerInstance);
            let dateEnd = new Date();
            let hours = dateEnd.getHours();
            let minutes = dateEnd.getMinutes();
            let seconds = dateEnd.getSeconds();
            let milliseconds = dateEnd.getMilliseconds();
            let completeTimeEnd = hours + 'h :' + minutes + 'm :' + seconds + 's :' + milliseconds + 'ms';
            let timeDiff = dateEnd.getTime() - dateStart.getTime();
            //@ts-ignore
            window.thronInitTracker.push({ element: playerEl, timeBegin: completeTimeStart, timeEnd: completeTimeEnd, executionTime: timeDiff + 'ms' });
            const productVideo = playerEl.closest('.product-image--animate, .product-gallery');
            if (productVideo) {
                this.pauseVideoElement = productVideo.querySelector('[data-pause]');
                if (productVideo.contains(productVideo.querySelector('.swiper-container'))) {
                    this.pauseVideoElement = playerEl.closest('.swiper-slide').querySelector('[data-pause]');
                }
                this.pauseVideo(this.pauseVideoElement, playerInstance);
            }
            const galleryVideo = playerEl.closest('.gallery-wrapper');
            if (galleryVideo) {
                this.pauseVideoElement = galleryVideo.querySelector('[data-pause]');
                if (galleryVideo.contains(galleryVideo.querySelector('.swiper-container'))) {
                    this.pauseVideoElement = playerEl.closest('.swiper-slide').querySelector('[data-pause]');
                }
                this.pauseVideo(this.pauseVideoElement, playerInstance);
            }
            const hero = playerEl.closest('.hero__hero-column');
            if (hero) {
                this.pauseVideoElement = hero.querySelector('[data-pause]');
                this.pauseVideo(this.pauseVideoElement, playerInstance);
                const muteVideoElement = hero.querySelector('[data-mute]');
                muteVideoElement === null || muteVideoElement === void 0 ? void 0 : muteVideoElement.addEventListener('click', () => {
                    if (muteVideoElement.getAttribute('aria-pressed') === 'true') {
                        muteVideoElement.setAttribute('aria-pressed', 'false');
                        playerInstance.volume(0);
                    }
                    else {
                        muteVideoElement.setAttribute('aria-pressed', 'true');
                        playerInstance.volume(1);
                    }
                });
            }
            const heroCarousel = playerEl.closest('.hero-carousel__main-wrapper');
            if (heroCarousel) {
                let slideIndex = (_a = playerEl.closest('.swiper-slide')) === null || _a === void 0 ? void 0 : _a.getAttribute('data-index');
                if (slideIndex) {
                    // pause button
                    this.pauseVideoElement = (_c = (_b = heroCarousel === null || heroCarousel === void 0 ? void 0 : heroCarousel.querySelector('.hero-carousel__slider-content')) === null || _b === void 0 ? void 0 : _b.querySelector('.swiper-slide[data-index="' + slideIndex + '"]')) === null || _c === void 0 ? void 0 : _c.querySelector('.video-pause');
                    (_d = this.pauseVideoElement) === null || _d === void 0 ? void 0 : _d.addEventListener('click', (e) => {
                        if (this.pauseVideoElement.getAttribute('aria-pressed') === 'true') {
                            this.pauseVideoElement.setAttribute('aria-pressed', 'false');
                            playerInstance.play();
                        }
                        else {
                            this.pauseVideoElement.setAttribute('aria-pressed', 'true');
                            playerInstance.pause();
                        }
                    });
                    // mute button [OE-16480]
                    const muteVideoElement = (_f = (_e = heroCarousel === null || heroCarousel === void 0 ? void 0 : heroCarousel.querySelector('.hero-carousel__slider-content')) === null || _e === void 0 ? void 0 : _e.querySelector('.swiper-slide[data-index="' + slideIndex + '"]')) === null || _f === void 0 ? void 0 : _f.querySelector('.btn--volume');
                    muteVideoElement === null || muteVideoElement === void 0 ? void 0 : muteVideoElement.addEventListener('click', (e) => {
                        if (muteVideoElement.getAttribute('aria-pressed') === 'true') {
                            muteVideoElement.setAttribute('aria-pressed', 'false');
                            playerInstance.volume(0);
                        }
                        else {
                            muteVideoElement.setAttribute('aria-pressed', 'true');
                            playerInstance.volume(1);
                        }
                    });
                }
            }
            const threeColumnMultimedia = playerEl.closest('.three-column-multimedia');
            if (threeColumnMultimedia) {
                this.pauseVideoElement = threeColumnMultimedia.querySelector('[data-pause]');
                if (this.pauseVideoElement) {
                    this.pauseVideoElement.dataset.pause = `${parseInt(this.pauseVideoElement.dataset.pause) + 1}`;
                    this.pauseVideoElement.dataset.totalVideos = `${parseInt(this.pauseVideoElement.dataset.totalVideos) + 1}`;
                    (_g = this.pauseVideoElement) === null || _g === void 0 ? void 0 : _g.addEventListener('click', (e) => {
                        e.preventDefault();
                        if (this.pauseVideoElement.getAttribute('aria-pressed') === 'true') {
                            this.pauseVideoElement.dataset.pause = `${parseInt(this.pauseVideoElement.dataset.pause) + 1}`;
                            playerInstance.play();
                            if (this.pauseVideoElement.dataset.pause === `${this.pauseVideoElement.dataset.totalVideos}`) {
                                this.pauseVideoElement.setAttribute('aria-pressed', 'false');
                            }
                        }
                        else {
                            this.pauseVideoElement.dataset.pause = `${parseInt(this.pauseVideoElement.dataset.pause) - 1}`;
                            playerInstance.pause();
                            if (this.pauseVideoElement.dataset.pause === '0') {
                                this.pauseVideoElement.setAttribute('aria-pressed', 'true');
                            }
                        }
                    });
                }
                const muteVideoElement = threeColumnMultimedia.querySelector('[data-mute]');
                if (muteVideoElement) {
                    muteVideoElement.dataset.mute = `${parseInt(muteVideoElement.dataset.mute) + 1}`;
                    muteVideoElement.dataset.totalVideos = `${parseInt(muteVideoElement.dataset.totalVideos) + 1}`;
                    muteVideoElement.addEventListener('click', () => {
                        playerInstance.volume(0);
                        if (muteVideoElement.getAttribute('aria-pressed') === 'true') {
                            muteVideoElement.dataset.mute = `${parseInt(muteVideoElement.dataset.mute) + 1}`;
                            if (muteVideoElement.dataset.mute === `${muteVideoElement.dataset.totalVideos}`) {
                                muteVideoElement.setAttribute('aria-pressed', 'false');
                            }
                        }
                        else {
                            playerInstance.volume(1);
                            muteVideoElement.dataset.mute = `${parseInt(muteVideoElement.dataset.mute) - 1}`;
                            if (muteVideoElement.dataset.mute === '0') {
                                muteVideoElement.setAttribute('aria-pressed', 'true');
                            }
                        }
                    });
                }
            }
            const technicalVideoWrapper = playerEl.closest('.technical-video-wrapper');
            if (technicalVideoWrapper) {
                const playVideoElement = technicalVideoWrapper.querySelector('[data-play]');
                const muteVideoElement = technicalVideoWrapper.querySelector('[data-mute]');
                // set initial state of the buttons
                if (options.autoplay) {
                    technicalVideoWrapper.classList.add('video-played');
                    technicalVideoWrapper.classList.add('show-controls');
                }
                if (!options.muted) {
                    muteVideoElement.setAttribute('aria-pressed', 'true');
                }
                let timeoutInMiliseconds = 3000;
                let timeoutId = 0;
                technicalVideoWrapper === null || technicalVideoWrapper === void 0 ? void 0 : technicalVideoWrapper.addEventListener('click', (e) => {
                    let target = e.target;
                    if (target.classList.contains('btn--volume'))
                        return;
                    // metto in pausa
                    if (technicalVideoWrapper.classList.contains('video-played')) {
                        playVideoElement.setAttribute('aria-pressed', 'true');
                        technicalVideoWrapper.classList.remove('video-played');
                        playerInstance.pause();
                    }
                    else {
                        playVideoElement.setAttribute('aria-pressed', 'false');
                        technicalVideoWrapper.classList.add('video-played');
                        playerInstance.play();
                    }
                });
                muteVideoElement === null || muteVideoElement === void 0 ? void 0 : muteVideoElement.addEventListener('click', () => {
                    if (muteVideoElement.getAttribute('aria-pressed') === 'true') {
                        muteVideoElement.setAttribute('aria-pressed', 'false');
                        playerInstance.volume(0);
                    }
                    else {
                        muteVideoElement.setAttribute('aria-pressed', 'true');
                        playerInstance.volume(1);
                    }
                });
                technicalVideoWrapper.addEventListener('mousemove', (e) => {
                    window.clearTimeout(timeoutId);
                    if (technicalVideoWrapper.classList.contains('video-played')) {
                        technicalVideoWrapper.classList.add('show-controls');
                        timeoutId = window.setTimeout(() => {
                            technicalVideoWrapper.classList.remove('show-controls');
                        }, timeoutInMiliseconds);
                    }
                });
            }
            const productVideoGeneric = playerEl.closest('.wrapper-product-video');
            if (productVideoGeneric) {
                this.pauseVideoElement = productVideoGeneric.querySelector('[data-pause]');
                this.pauseVideo(this.pauseVideoElement, playerInstance);
            }
            const videoContainer = playerEl.closest('.video-container');
            if (videoContainer) {
                if (!options.muted) {
                    // penso non sia corretto fare partire il video con l'audio
                    playerInstance.volume(1);
                }
                this.pauseVideoElement = videoContainer.querySelector('[data-pause]');
                this.pauseVideo(this.pauseVideoElement, playerInstance);
                const muteVideoElement = videoContainer.querySelector('[data-mute]');
                muteVideoElement === null || muteVideoElement === void 0 ? void 0 : muteVideoElement.addEventListener('click', () => {
                    if (muteVideoElement.getAttribute('aria-pressed') === 'true') {
                        muteVideoElement.setAttribute('aria-pressed', 'false');
                        playerInstance.volume(0);
                    }
                    else {
                        muteVideoElement.setAttribute('aria-pressed', 'true');
                        playerInstance.volume(1);
                    }
                });
            }
            if (this.onContentReady) {
                this.onContentReady(playerInstance);
            }
            // workaround in case autoplay dont work (mobile)
            // if (playerEl.dataset.optionAutoplay) {
            //   setTimeout(() => {
            //     playerInstance.play();
            //   }, 500);
            // }
        });
    }
    changeContent(id) {
        if (!this.playerInstance) {
            return;
        }
        const brandOptions = BRANDCONFIGS[window.brandId || 'MO'];
        const options = Object.assign(Object.assign(Object.assign(Object.assign({}, this.defaultOptions), { xcontentId: id }), brandOptions), this.$options);
        this.playerInstance.content(options);
    }
}
